module.exports = __webpack_public_path__ + "static/usine-72ed31f7cd9978f4278b4f70cc21b739.jpg";